import { AxiosService } from '../../../utils/AxiosService';
import Config from '../../../config';

const getUserProgress = async userId => await AxiosService.get(Config.server.api.progressApi + `admin/user/${userId}`, {}, true);

export default {
    getUserProgress
}